module.exports = __webpack_public_path__ + "img/ico-facturas-b.f1ba58a3.svg";